import { AxiosResponse } from "axios";
import { useQuery } from "react-query";

import { MainUrl } from "core/data/main-url";
import { IAxiosResult } from "../../models/axios-result.model";
import methods from "../interceptors/http.interceptor";
import { TGetCurrentUserFinancialTransactionsParams } from "core/models/financial.model";

const url = `${MainUrl}/api/store/FinancialTransaction`;

const GetCurrentUserFinancialTransactions = async (
  params: TGetCurrentUserFinancialTransactionsParams
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.post(
    `${url}/GetCurrentUserFinancialTransactions`,
    params
  );
};

export const useGetCurrentUserFinancialTransactions = (
  params: TGetCurrentUserFinancialTransactionsParams
) =>
  useQuery(["GetCurrentUserFinancialTransactions", params], () =>
    GetCurrentUserFinancialTransactions(params)
  );
